export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  date: string;
  tags: string[];
  imageUrl: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2024年双十一淘宝天猫隐藏优惠券领取全攻略',
    summary: '双十一大促期间，淘宝天猫平台隐藏着大量官方未公开的优惠券。本文手把手教你如何找到并领取这些隐藏福利，购物省钱的秘密都在这里。',
    content: `<h2>一、隐藏优惠券在哪里？</h2>
<p>很多用户只知道在商品详情页领取公开优惠券，但实际上淘宝天猫还有大量隐藏优惠券藏在以下渠道：</p>
<ul>
<li><strong>店铺首页</strong>：进入天猫旗舰店首页，下拉到店铺活动区，很多品牌会在双十一期间放置专属隐藏券。</li>
<li><strong>直播专属</strong>：关注品牌直播间，主播会不定时发放弹窗优惠券，这些券通常面额更大。</li>
<li><strong>客服暗号</strong>：向客服发送特定暗号（如"双11福利"、"隐藏优惠"），部分店铺会自动回复优惠券链接。</li>
<li><strong>会员中心</strong>：加入店铺会员后，会员中心经常有会员专属福利券。</li>
</ul>
<h2>二、领券最佳时间</h2>
<p>根据往年经验，以下几个时间点是领券黄金期：</p>
<ol>
<li>预售后1小时内 —— 大量高面额券放出</li>
<li>每晚8点 —— 品牌限时秒杀券</li>
<li>11月10日晚8点至11日凌晨2点 —— 终极福利券</li>
</ol>
<h2>三、注意事项</h2>
<p>隐藏优惠券通常有人数限制，建议开启消息通知，第一时间领取。同时注意查看使用门槛和有效期，避免领了用不了的尴尬。</p>`,
    category: 'ecommerce',
    categoryName: '电商优惠',
    date: '2024-10-15',
    tags: ['双十一', '淘宝', '优惠券', '省钱攻略'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Online%20shopping%20discount%20coupons%20concept%2C%20warm%20coral%20and%20gold%20abstract%20background%20with%20shopping%20bag%20silhouette%2C%20minimalist%20ecommerce%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20modern%20composition&width=800&height=500&seq=article-img-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: '京东PLUS会员到底值不值？2024年权益全面解析',
    summary: '京东PLUS会员年费上涨后，很多人犹豫是否续费。本文从实际使用角度对比分析PLUS会员的每一项权益，帮你算清楚这笔账。',
    content: `<h2>一、PLUS会员核心权益一览</h2>
<p>2024年京东PLUS会员年费调整为99元/年，主要权益包括：</p>
<ul>
<li><strong>10倍京豆</strong>：购物返10倍京豆，100京豆=1元，相当于额外返现0.5%-2%。</li>
<li><strong>运费券</strong>：每月5张6元运费券，全年价值360元。</li>
<li><strong>会员价</strong>：部分商品享PLUS专享价，平均优惠5%-15%。</li>
<li><strong>生活权益</strong>：含爱奇艺、腾讯视频、QQ音乐等联名会员。</li>
<li><strong>24小时客服</strong>：专属客服通道，退换货更便捷。</li>
</ul>
<h2>二、值不值得？算一笔账</h2>
<p>以一位月均消费1000元的用户为例：</p>
<p>京豆返利约120元/年 + 运费券价值360元 + 会员价优惠约200元 + 联名会员价值约200元 = 约880元/年</p>
<p>年费仅99元，回报率近9倍，对于经常在京东购物的用户来说绝对划算。</p>
<h2>三、哪些人不适合？</h2>
<p>如果月均消费低于200元，或者主要通过其他平台购物，PLUS会员的价值会大打折扣。</p>`,
    category: 'membership',
    categoryName: '会员权益',
    date: '2024-09-28',
    tags: ['京东', 'PLUS会员', '会员权益', '省钱'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20membership%20card%20concept%20with%20golden%20and%20warm%20amber%20abstract%20background%2C%20VIP%20crown%20icon%20silhouette%2C%20minimalist%20lifestyle%20illustration%2C%20soft%20elegant%20lighting%2C%20clean%20luxury%20composition&width=800&height=500&seq=article-img-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: '打工人必看！2024年各地租房补贴政策大盘点',
    summary: '一线城市租房压力大？其实很多城市都有针对年轻人的租房补贴政策。本文整理了北上广深杭等城市的租房福利，看看你能领多少。',
    content: `<h2>一、北京租房补贴政策</h2>
<p>北京市针对新就业无房职工和外来务工人员提供租房补贴：</p>
<ul>
<li><strong>补贴标准</strong>：根据区域不同，每月补贴200-1500元不等。</li>
<li><strong>申请条件</strong>：连续缴纳社保满12个月，家庭人均月收入低于规定标准。</li>
<li><strong>申请渠道</strong>：北京市住建委官网或各区住房保障窗口。</li>
</ul>
<h2>二、上海人才公寓与租房补贴</h2>
<p>上海各区对人才引进的租房支持力度持续加大：</p>
<ul>
<li><strong>浦东新区</strong>：符合条件的青年人才可申请每月最高3000元租房补贴。</li>
<li><strong>人才公寓</strong>：租金低于市场价30%-50%。</li>
</ul>
<h2>三、深圳毕业生租房补贴</h2>
<p>深圳对新引进人才提供一次性租房和生活补贴：本科15000元、硕士25000元、博士30000元。</p>
<h2>四、申请小贴士</h2>
<p>大部分城市租房补贴需要主动申请，不会自动发放。建议大家关注当地人社局或住建委的官方公众号，及时获取最新政策信息。</p>`,
    category: 'subsidy',
    categoryName: '生活补贴',
    date: '2024-09-15',
    tags: ['租房补贴', '城市福利', '打工人', '政策解读'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20building%20with%20warm%20coral%20and%20gold%20abstract%20accents%2C%20housing%20subsidy%20concept%20illustration%2C%20minimalist%20urban%20living%20scene%2C%20soft%20natural%20lighting%2C%20clean%20contemporary%20composition&width=800&height=500&seq=article-img-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: '2024年令人心动的offer：应届生求职补贴与安家费汇总',
    summary: '毕业季来临，除了关注薪资外，很多企业提供的求职补贴、安家费、人才引进奖励也是一笔不小的收入。一文看懂你能拿多少。',
    content: `<h2>一、求职面试补贴</h2>
<p>越来越多的企业为异地求职者提供面试差旅补贴：</p>
<ul>
<li><strong>互联网大厂</strong>：往返机票/高铁+住宿，面试通过后全额报销。</li>
<li><strong>金融机构</strong>：部分券商和银行提供2000-5000元的面试补贴。</li>
</ul>
<h2>二、入职安家费</h2>
<p>以下是2024年部分企业的安家费政策：</p>
<ul>
<li><strong>华为</strong>：根据城市和岗位，安家费3万-10万不等。</li>
<li><strong>字节跳动</strong>：提供一次性搬迁补贴，根据城市级别1万-3万。</li>
<li><strong>央企/国企</strong>：多数提供安家费+过渡性住房。</li>
</ul>
<h2>三、政府人才引进补贴</h2>
<p>各地政府对引进人才也有丰厚奖励，如杭州应届硕士可享3万元生活补贴+1万元租房补贴。</p>
<h2>四、如何最大化福利？</h2>
<p>建议在谈offer时主动询问企业是否有安家费、签字费、搬迁补贴等福利政策，很多HR不会主动提及这些隐藏福利。</p>`,
    category: 'career',
    categoryName: '职场福利',
    date: '2024-08-22',
    tags: ['应届生', '求职补贴', '安家费', '人才引进'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Career%20opportunity%20and%20job%20offer%20concept%2C%20warm%20coral%20and%20gold%20abstract%20background%2C%20briefcase%20and%20document%20silhouette%2C%20minimalist%20professional%20illustration%2C%20soft%20gradient%20lighting%2C%20clean%20corporate%20composition&width=800&height=500&seq=article-img-4&orientation=landscape',
  },
  {
    id: 'article-5',
    title: '学生党福利！各大平台免费会员领取指南（2024更新版）',
    summary: '在校大学生其实可以免费领取很多平台的会员权益。本文整理了支付宝、京东、网易云、B站等平台的学生认证福利，帮你省下一大笔钱。',
    content: `<h2>一、支付宝学生认证福利</h2>
<p>通过支付宝完成学生认证后，可享受：</p>
<ul>
<li><strong>海底捞6.9折</strong>：凭学生认证在支付宝领取。</li>
<li><strong>淘票票购票优惠</strong>：电影票立减10-20元。</li>
<li><strong>滴滴出行优惠</strong>：每月2张8折券。</li>
</ul>
<h2>二、视频/音乐会员</h2>
<p>以下平台均提供学生专属优惠：</p>
<ul>
<li><strong>爱奇艺学生会员</strong>：9.9元/月（原价25元）</li>
<li><strong>网易云音乐黑胶VIP学生价</strong>：7元/月</li>
<li><strong>B站大会员学生价</strong>：12.5元/季</li>
</ul>
<h2>三、京东校园专区</h2>
<p>京东针对学生用户开设了校园专区，认证后享专属学生价，部分商品折扣高达50%。</p>
<h2>四、更多隐藏福利</h2>
<p>Apple Music学生价5元/月、Office 365教育版免费使用、GitHub学生包（价值上千美元）等。只要你是全日制在校学生，这些福利统统可以免费或低价享受。</p>`,
    category: 'freebie',
    categoryName: '免费福利',
    date: '2024-08-10',
    tags: ['学生福利', '免费会员', '学生认证', '省钱'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Student%20discount%20and%20free%20benefits%20concept%2C%20warm%20coral%20and%20gold%20abstract%20background%2C%20graduation%20cap%20and%20gift%20box%20silhouette%2C%20minimalist%20education%20illustration%2C%20soft%20motivational%20lighting%2C%20clean%20modern%20composition&width=800&height=500&seq=article-img-5&orientation=landscape',
  },
  {
    id: 'article-6',
    title: '信用卡权益终极对决：2024年最值得办的5张神卡',
    summary: '信用卡权益五花八门，选不好等于白办。本文从日常消费、出行、餐饮、购物等多维度对比热门信用卡的真实价值，帮你找到最适合的那张。',
    content: `<h2>一、招商银行经典白金卡</h2>
<ul>
<li><strong>年费</strong>：3600元（可用积分抵扣）</li>
<li><strong>核心权益</strong>：无限次机场贵宾厅、每年6次免费酒店、300精选酒店权益</li>
<li><strong>适合人群</strong>：年消费20万以上、经常出差的商务人士</li>
</ul>
<h2>二、交通银行优逸白金卡</h2>
<ul>
<li><strong>年费</strong>：首年免，刷6次免次年</li>
<li><strong>核心权益</strong>：周五餐饮5折、积分兑换里程比例优秀</li>
<li><strong>适合人群</strong>：追求性价比的年轻白领</li>
</ul>
<h2>三、中信银行i白金卡</h2>
<ul>
<li><strong>年费</strong>：首年免，刷12次免次年</li>
<li><strong>核心权益</strong>：9元看电影、网络交易双倍积分</li>
<li><strong>适合人群</strong>：影视爱好者和网购达人</li>
</ul>
<h2>四、办卡建议</h2>
<p>不要被"白金"、"黑卡"等名头迷惑，选择信用卡最关键是看权益是否匹配自己的消费习惯。建议先确认自己每月的消费场景和金额，再选择对应的信用卡。</p>`,
    category: 'finance',
    categoryName: '金融福利',
    date: '2024-07-28',
    tags: ['信用卡', '权益对比', '金融福利', '办卡攻略'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Credit%20card%20rewards%20and%20financial%20benefits%20concept%2C%20warm%20gold%20and%20coral%20abstract%20background%2C%20credit%20card%20silhouette%20with%20sparkles%2C%20minimalist%20finance%20illustration%2C%20soft%20elegant%20lighting%2C%20clean%20premium%20composition&width=800&height=500&seq=article-img-6&orientation=landscape',
  },
  {
    id: 'article-7',
    title: '饿了么 vs 美团外卖：会员红包怎么买最省钱？',
    summary: '两大外卖平台会员体系深度对比，帮你算清楚饿了么超级吃货卡和美团外卖会员哪个更值得，以及如何叠加优惠最大化省钱。',
    content: `<h2>一、饿了么超级吃货卡</h2>
<ul>
<li><strong>价格</strong>：10元/月</li>
<li><strong>核心权益</strong>：每月4张5元通用红包，总价值20元</li>
<li><strong>隐藏福利</strong>：每月16号会员日可额外领取大额红包</li>
</ul>
<h2>二、美团外卖会员</h2>
<ul>
<li><strong>价格</strong>：15元/月</li>
<li><strong>核心权益</strong>：每月6张5元通用红包，总价值30元</li>
<li><strong>额外权益</strong>：部分商家可升级为更大面额红包</li>
</ul>
<h2>三、叠加优惠技巧</h2>
<p>除了会员红包外，以下叠加方式可以进一步省钱：</p>
<ol>
<li>使用银行信用卡支付，享随机立减</li>
<li>关注店铺粉丝群，领店铺专属券</li>
<li>拼单凑满减，用更少的红包覆盖更多订单</li>
</ol>
<h2>四、结论</h2>
<p>如果月点外卖10次以上，两个平台会员都值得开通。如果只在一个平台点单，美团会员性价比稍高；如果两个平台都用，饿了么会员更灵活。</p>`,
    category: 'ecommerce',
    categoryName: '电商优惠',
    date: '2024-07-15',
    tags: ['外卖', '饿了么', '美团', '会员对比'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20delivery%20app%20and%20membership%20comparison%20concept%2C%20warm%20coral%20and%20gold%20abstract%20background%2C%20food%20container%20and%20mobile%20phone%20silhouette%2C%20minimalist%20lifestyle%20illustration%2C%20soft%20appetizing%20lighting%2C%20clean%20modern%20composition&width=800&height=500&seq=article-img-7&orientation=landscape',
  },
  {
    id: 'article-8',
    title: '薅羊毛必备！2024年最全银行App签到领红包攻略',
    summary: '每天花几分钟在银行App签到，一年能白拿几百元红包。本文整理了工行、建行、招行、中行等主流银行App的签到福利活动。',
    content: `<h2>一、工商银行 - 融e行</h2>
<ul>
<li><strong>签到方式</strong>：每日打开App自动签到</li>
<li><strong>奖励</strong>：每次0.1-2元立减金，连续签到7天有额外奖励</li>
<li><strong>月预估收益</strong>：15-30元</li>
</ul>
<h2>二、建设银行 - 建行生活App</h2>
<ul>
<li><strong>签到方式</strong>：首页"每日签到"入口</li>
<li><strong>奖励</strong>：外卖券、商超券、话费券随机发放</li>
<li><strong>月预估收益</strong>：20-40元</li>
</ul>
<h2>三、招商银行 - 掌上生活</h2>
<ul>
<li><strong>签到方式</strong>：进入"我的"页面签到</li>
<li><strong>奖励</strong>：积分+优惠券组合</li>
<li><strong>月预估收益</strong>：积分价值约10-20元</li>
</ul>
<h2>四、中国银行 - 缤纷生活</h2>
<ul>
<li><strong>签到方式</strong>：首页签到入口</li>
<li><strong>奖励</strong>：话费券、视频会员、外卖券等</li>
<li><strong>月预估收益</strong>：15-25元</li>
</ul>
<h2>五、薅羊毛技巧</h2>
<p>建议每天早上通勤时统一签到，养成习惯后一年轻松白拿300-500元。可以设置手机闹钟提醒，避免遗漏。</p>`,
    category: 'finance',
    categoryName: '金融福利',
    date: '2024-07-08',
    tags: ['银行', '签到', '薅羊毛', '红包'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Mobile%20banking%20app%20daily%20check-in%20rewards%20concept%2C%20warm%20gold%20and%20coral%20abstract%20background%2C%20red%20envelope%20and%20coin%20silhouettes%2C%20minimalist%20finance%20illustration%2C%20soft%20festive%20lighting%2C%20clean%20modern%20composition&width=800&height=500&seq=article-img-8&orientation=landscape',
  },
  {
    id: 'article-9',
    title: '职场人必知：住房公积金除了买房还能怎么用？',
    summary: '很多人都以为公积金只能用来贷款买房，其实公积金的用途远比想象中多。租房、装修、大病医疗都可以提取，别再让这笔钱睡大觉了。',
    content: `<h2>一、公积金租房提取</h2>
<p>这是最常见的非购房使用场景。只要你连续足额缴存公积金满3个月，本人及配偶在缴存城市无自有住房且租赁住房的，就可以申请提取。</p>
<ul>
<li><strong>北京</strong>：每月最多提取1500元</li>
<li><strong>上海</strong>：每月最多提取2000元</li>
<li><strong>深圳</strong>：每月最多提取当月应缴存额的65%</li>
</ul>
<h2>二、装修提取</h2>
<p>部分城市允许提取公积金用于自住住房的大修和装修。需提供装修合同和费用发票，提取额度一般不超过实际装修费用。</p>
<h2>三、大病医疗提取</h2>
<p>如果本人或直系亲属患重大疾病，部分城市允许提取公积金用于支付医疗费用。需提供医院诊断证明和费用清单。</p>
<h2>四、离职提取</h2>
<p>非本地户籍职工离职后，可以一次性提取全部公积金余额。本地户籍职工需封存满6个月后方可提取。</p>
<h2>五、提醒</h2>
<p>各地公积金政策差异较大，具体以当地公积金管理中心最新政策为准。建议下载当地公积金App查询可提取金额和条件。</p>`,
    category: 'career',
    categoryName: '职场福利',
    date: '2024-06-20',
    tags: ['公积金', '租房提取', '职场福利', '政策解读'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Housing%20provident%20fund%20and%20financial%20planning%20concept%2C%20warm%20coral%20and%20gold%20abstract%20background%2C%20house%20and%20money%20silhouettes%2C%20minimalist%20real%20estate%20illustration%2C%20soft%20secure%20lighting%2C%20clean%20professional%20composition&width=800&height=500&seq=article-img-9&orientation=landscape',
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getHotArticles(limit: number = 6): Article[] {
  return [...articles].slice(0, limit);
}